import "./assets/css/main.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

// Components
import Navbar from "./components/Navbar/Navbar";
import Hero from "./components/Hero/Index";
import About from "./components/About/Index";
import Services from "./components/OurServices/Index";
import Portfolio from "./components/Portfolio/Index";
import EnterpriseERP from "./components/Portfolio/EnterpriseERP/EnterpriseERP";
import AISolutions from "./components/OurServices/AISolutions/AISolutions";
import CustomSoftware from "./components/OurServices/CustomSoftware/CustomSoftware";
import ERP from "./components/OurServices/POSERP/ERP";
import MobileDevelopment from "./components/OurServices/MobileDevelopment/MobileDevelopment";
import Contact from "./components/Contact/index";
import CloudDevOps from "./components/OurServices/CloudDevOps/CloudDevOps";
import Footer from "./components/Footer/Footer";
import Terms from "./components/Term/Terms";
import Privacy from "./components/Privacy/Privacy";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";

function App() {
  return (
    <Router>
      <Navbar />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Hero />} />

        <Route path="/Hero/index" element={<Hero />} />
        <Route path="/About/index" element={<About />} />
        <Route path="/OurServices/index" element={<Services />} />
        <Route
          path="/OurServices/AISolutions/AISolutions"
          element={<AISolutions />}
        />
        <Route
          path="/OurServices/CustomSoftware/CustomSoftware"
          element={<CustomSoftware />}
        />
        <Route path="/OurServices/ERP/ERP" element={<ERP />} />

        <Route path="/OurServices/ERP/ERP" element={<ERP />} />
        <Route
          path="/OurServices/MobileDevelopment/MobileDevelopment"
          element={<MobileDevelopment />}
        />

        <Route
          path="/OurServices/CloudDevOps/CloudDevOps"
          element={<CloudDevOps />}
        />
        <Route path="/Portfolio/index" element={<Portfolio />} />
        <Route
          path="/Portfolio/EnterpriseERP/index"
          element={<EnterpriseERP />}
        />
        <Route path="/Contact/index" element={<Contact />} />
        <Route path="/Term/terms" element={<Terms />} />
        <Route path="/Privacy/privacy" element={<Privacy />} />
      </Routes>

      <Footer />
    </Router>
  );
}

export default App;
